export default __webpack_public_path__ + "static/media/9_Intro.92612da3.mp4";